import { useLocale } from 'state/intl';
import { useLogger } from 'state/logger';

const EVENT_IDS = {
  CA: 'RUTR_CAN_22',
  US: 'RUTR_US_22',
};

export const useDetermineEventId = () => {
  const logger = useLogger();
  const { region } = useLocale();
  const eventIdForCountryCode = EVENT_IDS[region] || EVENT_IDS.CA;
  if (!eventIdForCountryCode && logger) {
    logger?.warn(`No eventId found for region ${region}`);
  }
  return eventIdForCountryCode;
};
